export default {
  cart: 'سلة المشتريات'
}
